import { type ReactNode, Children } from 'react';
import { isElement } from 'react-is';

import { ItemIcon } from './ItemIcon.js';
import { ItemTooltip } from './ItemTooltip.js';

/**
 * Defines slots into which children of this item should be rendered. There
 * are two special slots for the tooltip and the icon. Everything else will be
 * rendered into the freeform slot.
 */
type ItemSlots = {
  tooltip: ReactNode | null;
  icon: ReactNode | null;
  freeform: ReactNode[];
};

/** Iterates over child nodes to extract specific component slots. */
export function getItemSlots(children: ReactNode) {
  const slots: ItemSlots = {
    tooltip: null,
    icon: null,
    freeform: [],
  };

  Children.forEach(children, (child) => {
    if (isElement(child)) {
      switch (child.type) {
        case ItemTooltip:
          slots.tooltip = child;
          break;
        case ItemIcon:
          slots.icon = child;
          break;
        default:
          slots.freeform.push(child);
      }
    } else {
      slots.freeform.push(child);
    }
  });

  return slots;
}
